/**
 * 列表/详情 DTO 上的「是否展示编辑、流程处理、删除」开关（与后端 IsShow* 对齐）。
 * 兼容 PascalCase / camelCase 及常见英文别名。
 */

function truthy(v) {
  return v === true || v === 'true' || v === 1 || v === '1'
}

/** 按候选键顺序取第一个「已声明」的布尔值，均未声明则 false */
function pickBool(obj, keys) {
  if (!obj) return false
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (!Object.prototype.hasOwnProperty.call(obj, k)) continue
    return truthy(obj[k])
  }
  return false
}

/** 是否显示列表「编辑」（主单修改） */
export function rmaIsShowEdit(obj) {
  return pickBool(obj, [
    'isShow修改',
    'IsShow修改',
    'isShowEdit',
    'IsShowEdit',
  ])
}

/** 是否显示列表「处理」/ 详情内品质确认表单（品质部接收） */
export function rmaIsShowQualityReceive(obj) {
  return pickBool(obj, [
    'isShow品质部接收',
    'IsShow品质部接收',
    'isShowQualityReceive',
    'IsShowQualityReceive',
  ])
}

/** 是否显示列表「处理」/ 详情内工艺表单（工艺部处理） */
export function rmaIsShowEngineeringProcess(obj) {
  return pickBool(obj, [
    'isShow工艺部处理',
    'IsShow工艺部处理',
    'isShowEngineeringProcess',
    'IsShowEngineeringProcess',
  ])
}

/** 列表「处理」：任一路由为真则显示（进入详情办理当前环节） */
export function rmaIsShowProcessInList(obj) {
  return rmaIsShowQualityReceive(obj) || rmaIsShowEngineeringProcess(obj)
}

/** 是否显示列表/详情「删除」（与业务状态条件组合使用） */
export function rmaIsShowDelete(obj) {
  return pickBool(obj, [
    'isShow删除',
    'IsShow删除',
    'isShowDelete',
    'IsShowDelete',
  ])
}

/** 列表「责任判断」/ 详情内责任判定表单（待品质责任判定环节，与后端 IsShow 对齐） */
export function rmaIsShowLiabilityJudgment(obj) {
  return pickBool(obj, [
    'isShow责任判定',
    'IsShow责任判定',
    'isShowLiabilityJudgment',
    'IsShowLiabilityJudgment',
  ])
}

/** 创建/编辑弹窗内「现场确认」区块 — 占位键名，与后端 DTO 对齐后仅此数组替换 */
export function rmaIsShowOnSiteConfirmation(obj) {
  return pickBool(obj, [
    'isShow现场确认',
    'IsShow现场确认',
    'isShow现场确认状态',
    'IsShow现场确认状态',
    'isShowOnSiteConfirmation',
    'IsShowOnSiteConfirmation',
  ])
}

/** 「客退品仓入库」 */
export function rmaIsShowCustomerReturnWarehouseInbound(obj) {
  return pickBool(obj, [
    'isShow客退品仓入库',
    'IsShow客退品仓入库',
    'isShowCustomerReturnWarehouseInbound',
    'IsShowCustomerReturnWarehouseInbound',
  ])
}

/** 「补货处理」 */
export function rmaIsShowReplenishmentProcess(obj) {
  return pickBool(obj, [
    'isShow补货处理',
    'IsShow补货处理',
    'isShowReplenishmentProcess',
    'IsShowReplenishmentProcess',
  ])
}

/** 「退货处理」 */
export function rmaIsShowReturnProcess(obj) {
  return pickBool(obj, [
    'isShow退货处理',
    'IsShow退货处理',
    'isShowReturnProcess',
    'IsShowReturnProcess',
  ])
}

/** 列表「打印RMA单」（无后端打印接口时点击仅 Message 占位） */
export function rmaIsShowPrintRMA(obj) {
  return pickBool(obj, [
    'isShow打印RMA单',
    'IsShow打印RMA单',
    'isShowPrintRMA',
    'IsShowPrintRMA',
  ])
}
